/* unplugin-vue-components disabled */import script from "./GroupInvitationUIAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupInvitationUIAction.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__